export default __webpack_public_path__ + "static/9-north-island-label-9ba71a25fcc606374100bd59fbbddbf9.svg";